import React from 'react';
import Modal from '../base/Modal';
import Preloader from '../elements/Preloader';

class DemoModal extends React.Component {

  constructor(props) {
    super(props);

    this.toggleModal = this.toggleModal.bind(this)
  }

  toggleModal() {
    this.refs.modal.toggle()
  }

  render() {
    return (
      <section className="demo-section">
        <Modal className="modal-post scale" ref="modal">
          <div className="modal-content">
            <div className="modal-card">
              <div className="modal-post-header">
                <button className="btn btn-text text-semibold text-sm">vini175pa <i className="fa fa-angle-down sp-left-sm" /></button>
                <button className="btn btn-text-muted text-muted right"><i className="fa fa-cog" /></button>
              </div>
              <img src="https://67.media.tumblr.com/2af43f6ba6e3da9390722394e68c16cc/tumblr_oc5czpi6i51qz7t0xo1_540.jpg" className="fill-width" alt=""/>
              <div className="modal-body sp-xs-top-2">
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Error veniam, incidunt veritatis quia eaque nostrum dolor adipisci illo quibusdam placeat alias cupiditate debitis sint aut aperiam, expedita consequatur quasi deserunt.</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Error veniam, incidunt veritatis quia eaque nostrum dolor adipisci illo quibusdam placeat alias cupiditate debitis sint aut aperiam, expedita consequatur quasi deserunt.</p>
              </div>
              <div className="modal-footer">
                <button className="btn card-link small btn-outline-default" onClick={() => this.refs.modal.toggle()}>Cancel</button>
                <button className="btn card-link small btn-accent right"><Preloader medium light/></button>
              </div>
            </div>
          </div>
        </Modal>
        <h1 className="text-weight-light sp-xs-bottom-2 text-accent">Modal</h1>
        <div className="row">
          <div className="col-md-4">
            <button className="btn btn-primary text-uppercase btn-shadow" onClick={this.toggleModal}>Open modal</button>
          </div>
        </div>
      </section>
    );
  }
}

export default DemoModal;



/** WEBPACK FOOTER **
 ** ./src/components/demo/DemoModal.js
 **/